
import AnimatedSection from '../../../components/base/AnimatedSection';

const WA_PROGRAMA =
  "https://wa.me/5493415779623?text=Hola!%20Quiero%20el%20programa%20completo%20de%20la%20Formaci%C3%B3n%20de%20Pergamino%20en%20La%20Usina%20Norte";

export default function QueTeLlevas() {
  const items = [
    {
      icon: "ri-file-list-3-line",
      title: "Plantillas de prompts",
      desc: "Para tareas típicas de empresa.",
    },
    {
      icon: "ri-layout-grid-line",
      title: "Estructura para escribir",
      desc: "Pedidos claros y repetibles.",
    },
    {
      icon: "ri-checkbox-multiple-line",
      title: "Checklist para elegir tareas",
      desc: "Que conviene pasar a IA.",
    },
    {
      icon: "ri-flow-chart",
      title: "Flujo de Venta por WhatsApp",
      desc: "Aprendes técnicas de venta y aplicas con IA.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Plan de 30 días",
      desc: "Para aplicar lo aprendido en tu trabajo.",
    },
    {
      icon: "ri-award-line",
      title: "Diploma de asistencia",
      desc: "Certificado oficial del curso.",
    },
  ];

  const isValidLink = (url: string) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  return (
    <section className="py-20 bg-black">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto text-center">
          <AnimatedSection animation="fadeUp">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Qué te llevás
            </h2>
            <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
              Salís con material listo para usar.
            </p>
          </AnimatedSection>

          <div className="grid md:grid-cols-2 gap-8 mb-6 max-w-4xl mx-auto">
            {items.map((item, index) => (
              <AnimatedSection key={item.title} animation="fadeUp" delay={index * 100}>
                <div className="bg-gray-900 rounded-xl p-8 border border-gray-800 h-full">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-500 rounded-lg mb-4 mx-auto">
                    <i className={`${item.icon} text-3xl text-white`} />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">
                    {item.title}
                  </h3>
                  <p className="text-gray-400">{item.desc}</p>
                </div>
              </AnimatedSection>
            ))}
          </div>

          {/* Diploma */}
          <AnimatedSection animation="scaleUp" delay={100}>
            <div className="bg-gray-900 rounded-xl mb-12 border border-gray-800 max-w-3xl mx-auto overflow-hidden">
              <h3 className="text-2xl font-bold text-white mb-4 pt-6 px-6">
                Tu diploma de asistencia
              </h3>
              <div className="bg-gray-900">
                <img
                  alt="Diploma de asistencia MenteIA"
                  className="w-full h-auto"
                  src="https://static.readdy.ai/image/9d306f0d392a82ba4f7ef7b5bf276da1/e9e4e8878e2544656feb0f0e1f7b99e9.png"
                />
              </div>
              <p className="text-gray-400 py-4 text-lg px-6">
                Recibís tu diploma al finalizar el curso
              </p>
            </div>
          </AnimatedSection>

          {isValidLink(WA_PROGRAMA) && (
            <AnimatedSection animation="scaleUp" delay={200}>
              <div>
                <a
                  href={WA_PROGRAMA}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block px-8 py-4 bg-teal-500 text-white rounded-lg font-semibold text-lg hover:bg-teal-400 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-teal-500/50"
                >
                  Pedir el programa
                </a>
              </div>
            </AnimatedSection>
          )}
        </div>
      </div>
    </section>
  );
}
